// extracted by mini-css-extract-plugin
export default {"blue":"#004c97","orange":"#f76800","red":"#c00000","green":"#00a29b"};